<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资源中心</el-breadcrumb-item>
        <el-breadcrumb-item>电表终端采集</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">

        <el-tab-pane label="抄表采集列表" name="typeList">
        </el-tab-pane>
        <el-form :model="searchForm" ref="form" size="mini" :inline="true">
          <el-col :span="3">
          <el-form-item label="">
            <el-select v-model="searchForm.operatorId"  size="mini" placeholder="请选择运营商" clearable @change="changeOpertorId('val')">
              <el-option v-for="item in listForSelectTree" :key="item.value" :label="item.label"  :value="item.value">{{item.label}}</el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="3">
          <el-form-item label="">
            <el-select v-model="searchForm.stationId" size="mini" clearable placeholder="请选择站点" @change="changeStationId()">
              <el-option v-for="item in stations" :key="item.id" :label="item.stationName" :value="item.id">{{item.stationName}}</el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="meterTerminalName">

              <el-select v-model="searchForm.id" placeholder="请选择采集终端" clearable >
                <el-option v-for="item in meterAcquisitios" :key="item.id"
                  :label="item.meterTerminalName" :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="state">
              <el-select v-model="searchForm.state" placeholder="请选择终端状态" clearable @change="changeState(val)">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item prop="networkType">
              <el-select v-model="searchForm.networkType" placeholder="请选择终端网络" @change="changenetworkType(val)">
                <el-option v-for="item in optionsNetWork" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item>
              <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="1.5">
            <el-form-item label="">
              <el-button  v-if="checkPermission(['bee:res:terminal:insertOrUpdate'])" type="primary" size="mini" @click="add('新增')">新增</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="1.5">
            <el-form-item>
              <el-button v-if="checkPermission(['bee:res:terminal:page'])" type="primary" icon="el-icon-search" @click="submitSearchForm" :loading="getSearchLoading">查询
              </el-button>
            </el-form-item>
          </el-col>

        </el-form>

        <!--列表-->
        <el-table size="mini" @selection-change="selectChange" :data="tableData" highlight-current-row
          v-loading="searchLoading" border element-loading-text="拼命加载中" style="width: 100%;">
          <af-table-column align="center" prop="meterTerminalName" label="采集名称" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="meterTerminalCode" label="采集code" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="operatorId" label="运营商Code" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="name" label="运营商名" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="sim" label="终端卡号" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="meterNums" label="电表个数" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="state" :formatter="ifuserType" label="启动状态" min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="signals" label="信号幅值 " min-width="80px">
          </af-table-column>
          <af-table-column align="center" prop="imei" label="通信模块IMEI号码  " min-width="80px">
          </af-table-column>
          </af-table-column>
          <af-table-column label="操作" width="300px">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(['bee:res:terminal:insertOrUpdate'])" size="mini" @click="handleEdit(scope.$index, scope.row,'编辑')">编辑</el-button>
              <el-button size="mini" @click="selectEdit(scope.$index, scope.row,'详情')">详情</el-button>
              <el-button v-if="checkPermission(['bee:res:terminal:delete'])" size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>

            </template>
          </af-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage4" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
          :total="this.pageparam.total">
        </el-pagination>
      </el-tabs>
      <!-- 新增编辑界面 -->
      <el-dialog :title="tit" :visible.sync="editFormVisible" width="40%" :before-close="handleDialogClose">
        <div class="el-dialog-div">


          <el-form label-width="100px" ref="form" :model="addOrEditForm" :rules="rules" class="demo-ruleForm">
            <el-row>
              <el-col :span="10">
                <el-form-item label="采集名称" prop="meterTerminalName">
                  <el-input v-model="addOrEditForm.meterTerminalName" placeholder="请输入采集名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采集code" prop="meterTerminalCode">
                  <el-input v-model="addOrEditForm.meterTerminalCode" placeholder="请输入采集名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="采集状态" prop="state">
                  <el-select v-model="addOrEditForm.state" placeholder="请选择终端状态" @change="change('val')">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="协议类型" prop="agreementType">
                  <el-select v-model="addOrEditForm.agreementType" placeholder="请选择终端协议" :disabled="true">
                    <el-option v-for="item in agreementTypes" :key="item.value" :label="item.label" :value="0">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="版本" prop="nowVersion">
                  <el-input v-model="addOrEditForm.nowVersion" placeholder="请输入版本"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="网络" prop="networkType">
                  <el-select v-model="addOrEditForm.networkType" placeholder="请选择终端网络" @change="change('val')">
                    <el-option v-for="item in optionsNetWork" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="运营商" prop="operatorId">
                  <el-select v-model="addOrEditForm.operatorId" placeholder="请选择运营商" @change="changeOpertorId('val')">
                    <el-option v-for="item in listForSelectTree" :key="item.value" :label="item.label"
                      :value="item.value">{{item.label}}</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="充电站" prop="stationId">
                  <el-select v-model="addOrEditForm.stationId" placeholder="请选择站点" @change="changeStationId('val')">
                    <el-option v-for="item in stations" :key="item.id" :label="item.stationName" :value="item.id">
                      {{item.stationName}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="电表码" prop="meterCode">
                  <el-select v-model="addOrEditForm.meterCode" placeholder="请选择电表码(一个或多个)" multiple>
                    <el-option v-for="item in meterCodes" :key="item.meterCode" :label="item.meterCode"
                      :value="item.meterCode">{{item.meterCode}}</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!--               <el-form-item label="电表地址" prop="meterAddr">
                  <el-select v-model="addOrEditForm.meterAddr" placeholder="请选择站点" @change="change()">
                    <el-option v-for="item in meterAddrs" :key="item.id" :label="item.meterAddr" :value="item.id">
                      {{item.meterAddr}}</el-option>
                  </el-select>
                </el-form-item> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="信号幅值" prop="signals">
                  <el-input v-model="addOrEditForm.signals" placeholder="请输入信号幅值"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="IMEI号码" prop="imei">
                  <el-input v-model="addOrEditForm.imei" placeholder="请输入通信模块IMEI号码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="sim卡号码" prop="sim">
                  <el-input v-model="addOrEditForm.sim" placeholder="请输入sim卡号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="登录端口" prop="loginPort">
                  <el-input v-model="addOrEditForm.loginPort" placeholder="请输入端口"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="登录ip" prop="loginIp">
                  <el-input v-model="addOrEditForm.loginIp" placeholder="请输入登录ip"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="10">
                <el-form-item label="桩端费率" prop="timeSharingAccountingId">
                  <el-select v-model="addOrEditForm.timeSharingAccountingId" placeholder="桩端费率"
                    @change="change('val')">
                    <el-option v-for="item in serviceBillingRulesSelect" :key="item.id" :label="item.ruleName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('val')">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" @click="submitForm('addOrEditForm')">
            保存
          </el-button>

        </div>
      </el-dialog>
      <!-- 详情界面 -->
      <el-dialog :title="tit" :visible.sync="infoFormVisible" width="40%" :before-close="infoDialogClose">
        <div class="el-dialog-div">


          <el-form label-width="100px" :model="addOrEditForm">
            <el-row>
              <el-col :span="10">
                <el-form-item label="采集名称">
                  {{addOrEditForm.meterTerminalName}}

                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采集code">
                  {{addOrEditForm.meterTerminalCode}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="采集状态">
                  {{addOrEditForm.state}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="协议类型">
                  {{addOrEditForm.agreementType}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="版本">
                  {{addOrEditForm.nowVersion}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="网络">
                  {{addOrEditForm.networkTypeMsg}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>

              <el-col :span="10">
                <el-form-item label="电表地址">
                  {{addOrEditForm.meterAddrs}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="电表code">
                  {{addOrEditForm.meterCodeNums}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="站场编号">
                  {{addOrEditForm.stationCode}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="运营商号">
                  {{addOrEditForm.operatorId}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="imei号码">
                  {{addOrEditForm.imei}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="信号幅值">
                  {{addOrEditForm.signals}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="SIM卡号">
                  {{addOrEditForm.sim}}
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="登录端口">
                  {{addOrEditForm.loginPort}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="登录ip">
                  {{addOrEditForm.loginIp}}
                </el-form-item>

              </el-col>
              <el-col :span="10">
                <el-form-item label="电表个数">
                  {{addOrEditForm.meterNums}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="桩端费率" >
                  <el-select  disabled v-model="addOrEditForm.timeSharingAccountingId" placeholder="桩端费率"
                    @change="change('val')">
                    <el-option v-for="item in serviceBillingRulesSelect" :key="item.id" :label="item.ruleName" :value="item.id">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>

            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="infoClose('val')">取消</el-button>


        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from '@/module/operatingCenter/component/Pagination'
  import terminalApi from '@/module/resourceCenter/api/meterAcquisitionTerminalApi'
  import pileDateQueManagerApi from '@/module/resourceCenter/api/pileDateQueManagerApi'
  import configApi from '@/module/resourceCenter/api/meterConfigurationApi'
  import stationApi from '@/module/resourceCenter/api/stationApi';
  export default {

    name: 'personPileManager',
    data() {
      var isPriceVlidator = (rule, value, callback) => {
        var pattern = /^\d+.?\d{0,2}$/;
        if (!Number.isInteger(+value)) {
          callback(new Error('只能输入数字值'))
        } else return callback()
      }
      var validcodeip = (rule, value, callback) => {
        const reg =
          /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('输入格式不合法！'));
        }
      }
      var isPrice = (rule, value, callback) => {
        var pattern = /[^\d.]/g
        if (!pattern.test(value)) {
          callback(new Error('只能输入数字和小数点'))
        } else return callback()
      }

      return {
        searchForm: {
          meterTerminalName: '',
          state: '',
          id:'',
          nowVersion: '',
          operatorId:'',
          stationId:'',
          networkType: '',
          loginPort: '',
          loginIp: '',
        },
        form: {},
        meterAcquisitios:[],
        editForm: {},
        editFormVisible: false,
        loading: false,
        tableData: [],

        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        // rules表单验证
        rules: {
          meterTerminalName: [{
            required: true,
            message: '请输入采集终端名',
            trigger: 'blur'
          }],
          stationId: [{
            required: true,
            message: '请选择采集站点',
            trigger: 'blur'
          }],
          meterTerminalCode: [{
            required: true,
            message: '请输入采集终端code',
            trigger: 'blur'
          }, {
            validator: isPriceVlidator,
            message: '采集终端code只能是数字',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: '请选择状态',
            trigger: 'blur'
          }],


          agreementType: [{
            required: true,
            message: '请输入信号幅值',
            trigger: 'blur'
          }],


          operatorId: [{
            required: true,
            message: '请输入登录端口',
            trigger: 'blur'
          }],
          timeSharingAccountingId: [{
            required: true,
            message: '请选择汇率id',
            trigger: 'blur'
          }],

        },
        meterAddrs: [],
        meterCodes: [],
        currentPage4: 0,
        tit: '',
        addOrEditForm: {
          id: '',
          meterTerminalName: '',
          meterTerminalCode: '',
          meterNums: '',
          meterCodeNums: '',
          stationCode: '',
          state: '',
          agreementType: 0,
          networkType: '',
          networkTypeMsg: '',
          nowVersion: '',
          operatorId: '',
          stationId: '',
          meterCode: '',
          signals: '',
          meterAddrs: '',
          imei: '',
          sim: '',
          loginPort: '',
          meterAddr: '',
          loginIp: '',
          timeSharingAccountingId:''
        },
        changeEditForm: {
          id: '',
          meterTerminalName: '',
          meterTerminalCode: '',
          meterNums: '',
          meterCodeNums: '',
          stationCode: '',
          state: '',
          agreementType: 0,
          networkType: '',
          networkTypeMsg: '',
          nowVersion: '',
          operatorId: '',
          stationId: '',
          meterCode: '',
          signals: '',
          meterAddrs: '',
          imei: '',
          sim: '',
          loginPort: '',
          meterAddr: '',
          loginIp: '',
           timeSharingAccountingId:''
        },
        options2:[],
        options: [{
          value: 0,
          label: '离线'
        }, {
          value: 1,
          label: '在线'
        }, {
          value: 2,
          label: '故障'
        }],
        optionsNetWork: [{
          value: 0,
          label: '有线网'
        }, {
          value: 1,
          label: '无线网'
        }],
        stations: [],
        listForSelectTree: [],
        agreementTypes: [{
          value: '0',
          label: '氪技云'
        }],
        activeName: '',
        listLoading: '',
        showFilters: true,
        getSearchLoading: false,
        searchLoading: false,
        showViewVisible: false,
        infoFormVisible: false,
        id:'',
        typeEdit: {},
        show3: false,
        enumData: [],
        editSubmitLoading: false,
        input: '',
        dialogFormVisible: false,
        val_time: '',
        serviceBillingRulesSelect: [],
        formLabelWidth: '120px'
      }
    },
    components: {
      Pagination,
    },
    created() {
      this.getdata()
      this.getlistForSelectTree(null)
      this.getServiceBillingRulesSelect([])
    },
    methods: {
      submitSearchForm() {
        this.getdata()
      },
      selectEdit(index, row, val) {
        console.log(row)
        this.info(row, val)
        this.tit = val
        console.log(this.ifuserType(row))
        this.ifuserTypes(row.networkType)
        this.ifuserTypea(row.agreementType)
        this.addOrEditForm.meterNums = row.meterNums
        this.addOrEditForm.meterCodeNums = row.meterCodeNums;
        this.addOrEditForm.networkTypeMsg = row.networkType.message
        this.addOrEditForm.meterAddrs = row.meterAddrs
        this.infoFormVisible = true
      },
      info(row, val) {
        this.addOrEditForm.id = row.id
        this.id =row.id
        this.addOrEditForm.meterTerminalName = row.meterTerminalName
        this.addOrEditForm.meterTerminalCode = row.meterTerminalCode

        this.addOrEditForm.state = row.state

        this.addOrEditForm.agreementType = row.agreementType

        this.addOrEditForm.networkType = row.networkType.code
        this.addOrEditForm.operatorId = row.operatorId
        this.addOrEditForm.nowVersion = row.nowVersion
        this.addOrEditForm.sim = row.sim
        this.addOrEditForm.stationId = row.stationId
        this.addOrEditForm.stationCode = row.stationCode
        this.addOrEditForm.meterCode = row.meterCode
        this.addOrEditForm.nowVersion = row.nowVersion
        this.addOrEditForm.timeSharingAccountingId = row.timeSharingAccountingId
        if (row.meterCodeNums != null && row.meterCodeNums != '') {
          this.addOrEditForm.meterCode = row.meterCodeNums.split(',')
        }

        this.addOrEditForm.signals = row.signals
        this.addOrEditForm.imei = row.imei
        this.addOrEditForm.loginPort = row.loginPort
        this.addOrEditForm.loginIp = row.loginIp
      },
      infoDialogClose() {
        this.infoFormVisible = false

        this.celerForm(this.addOrEditForm)
      },
      infoClose() {

        this.infoDialogClose()
      },

      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            console.log(row.id)
            terminalApi.deleteTerminal(row.id)
              .then(res => {
                if (res.code === 0) {
                  this.$message({
                    type: 'success',
                    message: '数据已删除'
                  })


                  this.getdata()

                  this.handleDialogClose();
                } else {
                  this.$message({
                    type: 'info',
                    message: res.data.msg
                  })

                  this.handleDialogClose();
                }
              })
          })
      },
      handleEdit(index, row, val) {
        this.tit = val
        this.editFormVisible = true
        this.info(row)
        let par = []
        console.log(row)
        this.addOrEditForm.id= row.id

        if (this.addOrEditForm.operatorId != null) {

          par.push(this.addOrEditForm.operatorId);
        }
        // this.evlats('val')
        // this.evlat('val')
        this.getMeterCodes()
        this.getstationData(par)
      },

      resetSearchForm() {
        this.celerForm1(this.searchForm)

      },
      changeState() {},
      celerForm(from) {
        for (let item in from) {
          if (from[item]) {
            from[item] = ''
          }
        }
        from = Object.assign({}, this.changeEditForm)
        this.addOrEditForm= Object.assign({}, this.changeEditForm)
        console.log(from)

      },
      celerForm1(from) {
        for (let item in from) {
          if (from[item]) {
            from[item] = ''
          }
        }
        from.networkType=''
        from.state=''
        console.log(from)

      },
      selectChange() {},
      change(val) {
        this.$forceUpdate()
      },
      close() {
        console.log("a")
        this.$confirm('确定要取消吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.handleDialogClose()
          })
      },
      handleDialogClose() {
        this.editFormVisible = false
        this.celerForm(this.addOrEditForm)

        this.$refs.form.resetFields();
        this.addOrEditForm.agreementType = 0
      },
      evlat(val) {
        this.$forceUpdate()
        console.log(this.searchForm.operatorId)
        let par = []

        if (this.addOrEditForm.operatorId != null) {
          par.push(this.addOrEditForm.operatorId);
          this.getstationData(par)
          this.addOrEditForm.stationId = null

        }
      },
      changeOpertorId(val){
        this.$forceUpdate()
        console.log(this.searchForm.operatorId)
        let par = []
        console.log(this.searchForm.operatorId)
        if (this.searchForm.operatorId != null && this.searchForm.operatorId !='') {
          par.push(this.searchForm.operatorId);
          this.getstationData(par)
          this.getServiceBillingRulesSelect(par);
        }
        if(this.addOrEditForm.operatorId!=null && this.addOrEditForm.operatorId !=""){
          par.push(this.addOrEditForm.operatorId);
          this.getstationData(par)
          this.getServiceBillingRulesSelect(par);
        }
        this.addOrEditForm.stationId = null
        this.meterAcquisitios=[]
         this.addOrEditForm.id = null
        this.searchForm.stationId = null
        this.meterAcquisitios=[]
         this.searchForm.id = null
      },
      getServiceBillingRulesSelect(params) {
        stationApi.getRateSelectByOperatorId(params).then((res) => {
          console.info(JSON.stringify(res))
          this.serviceBillingRulesSelect = res
        })
      },
      evlats(val) {
        this.addOrEditForm.meterCode = ''
        this.addOrEditForm.meterAddr = ''

        this.getMeterCodes()
        // this.getMeterAddrs()
      },
      // getMeterAddrs(){
      //   if (this.addOrEditForm.stationId != null) {
      //     terminalApi.getMeterAddrList(this.addOrEditForm.stationId).then((res) => {
      //       console.log(res.data)
      //       this.meterAddrs = res.data
      //     })
      //   }
      // },
      getMeterCodes() {
        if (this.addOrEditForm.stationId != null && this.addOrEditForm.stationId !="") {
          terminalApi.getMeterCodeList(this.addOrEditForm.stationId).then((res) => {
            console.log(res.data)
            this.meterCodes = res.data
          })
        }
      },
      // 编辑、添加提交方法
      submitForm(editData) {
        var meterCode = ''
        if (this.addOrEditForm.meterCode && this.addOrEditForm.meterCode != '') {
          meterCode = this.addOrEditForm.meterCode.join(',')
        }


        this.addOrEditForm.meterCodeNums = meterCode
        if (this.addOrEditForm.state != null && this.addOrEditForm.state === "在线") {
          this.addOrEditForm.state = 0
        }
        if (this.addOrEditForm.state != null && this.addOrEditForm.state === "离线") {
          this.addOrEditForm.state = 1
        }
        if (this.addOrEditForm.state != null && this.addOrEditForm.state === "故障") {
          this.addOrEditForm.state = 3
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$confirm('确定要提交吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                terminalApi.inOrUpdate(this.addOrEditForm)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message({
                        type: 'success',
                        message: '数据已提交'
                      })
                      this.getdata()

                      this.handleDialogClose();
                    } else {
                      this.$message({
                        type: 'info',
                        message: res.data.msg
                      })

                      this.handleDialogClose();
                    }
                  })
                  .catch(err => {
                    this.loading = false
                    console.log(this.addOrEditForm)
                    this.handleDialogClose();

                    this.getdata()
                    this.$message.error('数据提交失败')
                  })
              })
            // 向后台发送请求
          } else {
            this.$message('请填写相关内容');

            //就像用户提示发生错误的消息
          }
        })
      },
      getlistForSelectTree(val) {
        let param = {};
        let par = []
        configApi.getlistForSelectTree(param).then((res) => {
          if (res.code === 0) {
            this.listForSelectTree = res.data
            if (val == null) {
              for (var i = 0; i < res.data.length; i++) {
                par.push(res.data[i].value);
              }
            } else {
              par.push(val);
            }
            this.getstationData(par)
          }
        })
      },
      //获取所有的站点
      getstationData(param) {
        configApi.alarmStationAll(param).then((res) => {
          if (res.code === 0) {
            this.stations = res.data
          } else {
            this.$message.error(res.message)
          }

        })
      },
      changeStationId(){
        this.$forceUpdate()

        let par =this.searchForm.stationId
        console.log(this.searchForm.operatorId)
        if (this.searchForm.stationId != null && this.searchForm.stationId !="") {

          this.meterAcquisitionTerminalList(par)


        }
        if (this.addOrEditForm.stationId != null && this.addOrEditForm.stationId !="") {
          par=this.addOrEditForm.stationId
          this.getMeterCodes(par)


        }
                 this.searchForm.id = null

      },
      meterAcquisitionTerminalList(param){
        console.log(param)
        pileDateQueManagerApi.getMeterAcquisitionTerminalByStationId(param).then((res) => {
          if (res.code === 0) {
            this.meterAcquisitios = res.data
          } else {
            this.$message.error(res.message)
          }

        })
      },
      evlat(val){
        let par =[]
        par.push(this.searchForm.operatorId)
        this.getstationData(par)
      },
      handleSizeChange(val) {
        this.pageparam.pageSize = val
        this.getdata();
      },
      handleCurrentChange(val) {
        this.pageparam.currentPage = val
        this.getdata();
      },
      handleClick() {},
      // 获取数据方法
      getdata() {

        this.searchLoading = true
        this.getSearchLoading = true
        // let param = Object.assign({}, this.stationSearchForm)
        // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');

        this.pageparam.t = this.searchForm
        let param = Object.assign({}, this.pageparam)
        console.log(param)
        terminalApi.queryAll(param).then((res) => {
          if (res.code === 0) {

            this.tableData = res.data.list
            this.pageparam.total = res.data.total
            // this.$message({
            //   message: res.message,
            //   type: 'success'
            // })
          } else {
            this.$message.error(res.message)
          }
          this.searchLoading = false
          this.getSearchLoading = false
        })
      },
      add(val) {
        this.tit = val
        this.addOrEditForm.networkType = ''
        this.addOrEditForm.state = ''
        this.addOrEditForm.agreementType = 0
        this.editFormVisible = true
      },
      ifuserTypes(val) {

        if (val == 0) {
          console.log(val)
          this.addOrEditForm.networkType = "有线网"

        } else if (val == 1) {
          this.addOrEditForm.networkType = "无线网"

        }
      },
      ifuserTypea(val) {
        this.addOrEditForm.agreementType = "氪技云"
      },
      ifuserType(val) {

        if (val.state == 0) {
          this.addOrEditForm.state = "离线"
          return "离线"
        } else if (val.state == 1) {
          this.addOrEditForm.state = "在线"
          return "在线"
        } else if (val.state == 2) {
          this.addOrEditForm.state = "故障"
          return "故障"
        }

      }
    },
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/acquisitionManager.vue